import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Syska { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '日期 (KA001) 不可空白'}) 
    @MaxLength(8,{message: '日期 (KA001) 資料太長'})
    KA001: string = '';            // 日期 8 定時設定是SYSSE

    @IsNotEmpty({message: '時間 (KA002) 不可空白'}) 
    @MaxLength(12,{message: '時間 (KA002) 資料太長'})
    KA002: string = '';            // 時間 12 原本4->12  hh:mm:ss:123

    @IsNotEmpty({message: '公司代號 (KA003) 不可空白'}) 
    @MaxLength(30,{message: '公司代號 (KA003) 資料太長'})
    KA003: string = '';            // 公司代號 30 DBNAME   OLD:10

    @IsNotEmpty({message: '程式代號 (KA004) 不可空白'}) 
    @MaxLength(20,{message: '程式代號 (KA004) 資料太長'})
    KA004: string = '';            // 程式代號 20 

    @MaxLength(10,{message: '保留 (KA005) 資料太長'})
    KA005: string = '';            // 保留 10 處理狀態

    @IsNumber() 
    KA006: number = 0;            // 處理進度 1 {{0:等待中  1:進行中 5:失敗 9:完成}}

    @MaxLength(15,{message: '工作電腦 (KA007) 資料太長'})
    KA007: string = '';            // 工作電腦 15 

    @MaxLength(20,{message: '分類 (KA008) 資料太長'})
    KA008: string = '';            // 分類 20 {{批次:批次 報表:報表 API:API批次}}  檔名:KA001+'-'+KA002+'-'+KA004+'.PDF'


    KA009: Date | undefined;            // 開始時間 0 


    KA010: Date | undefined;            // 完成時間 0 

    KA011: string = '';            // 處理結果 0 

    @IsNumber() 
    KA012: number = 0;            // 錯誤個數 8 XXX 個數

    @IsNumber() 
    KA013: number = 0;            // 警告個數 8 WWW 個數

    @MaxLength(300,{message: '參數內容 (KA014) 資料太長'})
    KA014: string = '';            // 參數內容 300 

    @MaxLength(10,{message: '使用者代號 (KA015) 資料太長'})
    KA015: string = '';            // 使用者代號 10 

    @MaxLength(14,{message: '定時工作代號 (KA016) 資料太長'})
    KA016: string = '';            // 定時工作代號 14 SYSSE.JOBID

    @IsNumber() 
    KA017: number = 0;            // 成功筆數 8 

    @IsNumber() 
    KA018: number = 0;            // 失敗筆數 8 

    @MaxLength(1,{message: 'MAIL通知方式 (KA019) 資料太長'})
    KA019: string = '';            // MAIL通知方式 1 {{空白:不通知  1:有錯誤通知 2:有錯誤或警告通知 3:完成就通知}}  <-- SYS.SE116

    @MaxLength(255,{message: 'MAIL帳號 (KA020) 資料太長'})
    KA020: string = '';            // MAIL帳號 255 可多個MAIL 逗號分開 <-- SYS.SE117

    @MaxLength(255,{message: 'API名稱 (NAME1) 資料太長'})
    NAME1: string = '';            // API名稱 255 


}
